import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, query, getDocs } from 'firebase/firestore';
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { Loader2 } from 'lucide-react';

// --- TopReportedProjects import has been removed ---

const COLORS = ['#06b6d4', '#a855f7', '#f59e0b', '#10b981', '#ef4444', '#3b82f6'];

export default function AnalyticsPage() {
  const [chartData, setChartData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const [postsSnapshot, matrixSnapshot] = await Promise.all([
        getDocs(query(collection(db, 'posts'))),
        getDocs(query(collection(db, 'fraudMatrix'))),
      ]);

      const matrixNodes = matrixSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      const posts = postsSnapshot.docs.map(doc => doc.data());

      const counts = {};
      posts.forEach(post => {
        if (post.type === 'CFE' && post.fraudMatrixId) {
          counts[post.fraudMatrixId] = (counts[post.fraudMatrixId] || 0) + 1;
        }
      });

      const formattedData = Object.keys(counts).map(matrixId => {
        const node = matrixNodes.find(n => n.id === matrixId);
        return {
          name: node ? node.name : 'Other',
          value: counts[matrixId],
        };
      });

      setChartData(formattedData);
      setLoading(false);
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="flex flex-col items-center justify-center h-64">
        <Loader2 className="animate-spin text-cyan-400" size={48} />
        <p className="text-gray-400 mt-4">Loading Analytics...</p>
      </div>
    );
  }

  return (
    <div className="space-y-8">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-white mb-2">CFE Analytics</h1>
        <p className="text-gray-400">An overview of community-reported fraud types.</p>
      </div>

      {/* --- The <TopReportedProjects /> component has been removed from here --- */}

      <div className="glass-card rounded-2xl p-8">
        <h3 className="text-xl font-bold text-white mb-4 text-center">Reports by Fraud Category</h3>
        <div className="w-full h-96">
            {chartData.length > 0 ? (
            <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                <Pie
                    data={chartData}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    outerRadius={120}
                    fill="#8884d8"
                    dataKey="value"
                    nameKey="name"
                    label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                >
                    {chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                </Pie>
                <Tooltip
                    contentStyle={{ 
                        background: 'rgba(30, 41, 59, 0.8)', 
                        borderColor: '#4b5563',
                        color: '#cbd5e1'
                    }}
                />
                <Legend />
                </PieChart>
            </ResponsiveContainer>
            ) : (
                <div className="flex justify-center items-center h-full">
                    <p className="text-gray-500">No categorized report data to display.</p>
                </div>
            )}
        </div>
      </div>
    </div>
  );
}